/* 21 Oct 2026 (Joe): the visitor's own light/dark choice, applied before the page paints (no flash). No choice = follow the device. */
(function(){try{var t=localStorage.getItem('lemyn.theme');if(t==='dark'||t==='light')document.documentElement.setAttribute('data-theme',t);}catch(e){}})();
/* lemyn-router.js — the shadow theme's one piece of glue (10 Oct 2026).
   The pages are the mockup pages, unchanged. Inside them every link still says "shop.html", "product-12oz.html" …
   This file maps those names to the real Shopify addresses when someone clicks, so every page keeps working exactly
   as in the mockup (Quick look, the concierge, the cart drawer) and lands on the real store.
   Images and data load from the theme's assets folder through the page's <base> tag. */
(function(){
var H={
 'index.html':'/',
 'shop.html':'/collections/organic-hand-sanitizer',
 'face-oils.html':'/collections/face-serums',
 'essential-oils.html':'/collections/essential-oils',
 'product-12oz.html':'/products/organic-hand-sanitizer-gel-safe-for-sensitive-skin-ages-3-99-medical-grade-made-in-the-usa-12-fl-oz-with-pump',
 'product-8oz.html':'/products/organic-hand-sanitizer-gel-safe-for-sensitive-skin-ages-3-99-medical-grade-made-in-the-usa-8-fl-oz-with-pump',
 'product-flip.html':'/products/organic-hand-sanitizer-gel-safe-for-sensitive-skin-ages-3-99-medical-grade-made-in-the-usa-8-fl-oz-with-flip-top',
 'product-2oz.html':'/products/organic-hand-sanitizer-gel-safe-for-sensitive-skin-ages-3-99-medical-grade-made-in-the-usa-2-fl-oz',
 'serum-uno.html':'/products/no-uno-radiant-aura-luxury-face-oil-serum-vitamin-c-infused',
 'serum-jojo.html':'/products/golden-jojoba-face-oil-vitamin-c-e-supercharged-organic',
 'serum-maru.html':'/products/organic-marula-oil-vitamin-c-e-supercharged',
 'serum-plum.html':'/products/organic-plum-face-oil-vitamin-c-e-supercharged',
 'serum-pear.html':'/products/prickly-pear-plum-face-oil-vitamin-c-e-supercharged-organic',
 'serum-rose.html':'/products/squalane-vitamin-c-rose-oil-enhanced-with-carotenoids-and-vitamin-e-freshly-made',
 'serum-ret.html':'/products/retinol-2-facial-oil-serum',
 'serum-arg.html':'/products/argireline-youth-peptide-face-oil-serum',
 'eo-sleep-roll.html':'/products/sleep-organic-essential-oil-roll-on-sleep-elixir-for-restful-sleep-and-relaxation',
 'eo-sleep-drop.html':'/products/sleep-organic-essential-oil-blend-elixir-for-restful-sleep-and-relaxation-undiluted-100-pure',
 'eo-breathe-roll.html':'/products/breathe-breathe-easy-with-organic-essential-oil-roll-on',
 'eo-breathe-drop.html':'/products/breathe-breathe-easy-organic-essential-oil-blend-undiluted-100-pure',
 'eo-happy-roll.html':'/products/happy-uplift-essence-organic-essential-oil-roll-on',
 'eo-happy-drop.html':'/products/happy-uplift-essence-organic-essential-oil-blend-undiluted-100-pure-for-diffuser',
 'pro.html':'/pages/lemyn-pro',
 'privacy.html':'/policies/privacy-policy',
 'terms.html':'/policies/terms-of-service',
 'shipping-returns.html':'/policies/refund-policy',
 'sms-terms.html':'/pages/mobile-message-service-terms-and-conditions'
};
/* keep the theme preview going from page to page (only while previewing the hidden theme) */
var PV=(location.search.match(/[?&](preview_theme_id=\d+)/)||[])[1]||'';
function map(href){
  if(href==null) return null;
  var s=String(href), hash='', q='';
  var hi=s.indexOf('#'); if(hi>=0){ hash=s.slice(hi); s=s.slice(0,hi); }
  if(s===''){ return hash?{hash:hash}:null; }
  var qi=s.indexOf('?'); if(qi>=0){ q=s.slice(qi); s=s.slice(0,qi); }
  var f=s.split('/').pop();
  if(!/^[a-z0-9\-]+\.html$/i.test(f)||/^https?:/i.test(s)) return null;
  var p=H[f.toLowerCase()]; if(!p) return null;
  if(PV) q=q?q+'&'+PV:'?'+PV;
  return {url:p+q+hash};
}
window.LEMYN_URL=function(href){ var m=map(href); return m&&m.url?m.url:href; };
window.LEMYN_GO=function(href){ var m=map(href); if(m&&m.hash&&!m.url){ jump(m.hash); return; } location.href=m&&m.url?m.url:href; };
function jump(hash){
  var id=decodeURIComponent(hash.slice(1)), t=id&&document.getElementById(id);
  try{ history.replaceState(null,'',location.pathname+location.search+hash); }catch(e){}
  if(t) t.scrollIntoView({behavior:'smooth',block:'start'}); else if(!id) window.scrollTo({top:0,behavior:'smooth'});
  try{ window.dispatchEvent(new HashChangeEvent('hashchange')); }catch(e){}
}
/* every mockup link gets its real address in the page itself (taps, long-press, new tab and Google all work
   without help); the mockup name stays in data-lf for Quick look and the concierge */
function fix(root){
  var list=root.querySelectorAll?root.querySelectorAll('a[href]'):[];
  if(root.matches&&root.matches('a[href]')) list=[root].concat([].slice.call(list));
  [].forEach.call(list,function(a){ var raw=a.getAttribute('href'), m=map(raw); if(m&&m.url){ a.setAttribute('data-lf',raw); a.setAttribute('href',m.url); } });
}
function watch(){
  fix(document);
  new MutationObserver(function(ms){ ms.forEach(function(mu){
    if(mu.type==='attributes') fix(mu.target); else [].forEach.call(mu.addedNodes,function(n){ if(n.nodeType===1) fix(n); });
  }); }).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',watch); else watch();
/* on a chooser, a link to a detail page still opens its Quick look (the closed loop, #48) */
window.addEventListener('click',function(e){
  if(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
  var a=e.target&&e.target.closest&&e.target.closest('a[data-lf]'); if(!a||a.closest('.ql')||typeof window.lemynQuickLookFor!=='function') return; /* "Full details" inside the Quick look really goes to the page */
  if(window.lemynQuickLookFor(a.getAttribute('data-lf'))){ e.preventDefault(); e.stopPropagation(); }
},true);
/* "back to cart" from Shopify's checkout lands on /cart. That page sends the visitor back to the last page they
   were on, with our cart drawer open (10 Oct, Joe: "the real cart, not this black site"). */
if(window.LEMYN_FILE){ try{ localStorage.setItem('lemyn.last', location.pathname); }catch(e){} }
if(location.hash==='#cart'){
  try{ history.replaceState(null,'',location.pathname+location.search); }catch(e){}
  addEventListener('load',function(){ var n=0; (function tryOpen(){ if(typeof window.lemynOpenCart==='function'){ window.lemynOpenCart(); } else if(n++<20){ setTimeout(tryOpen,100); } })(); });
}
/* homepage on a phone: the two hero buttons were hidden for a bottom bar that no longer exists (walk-through #3) */
var cs=document.createElement('style'); cs.textContent='@media(max-width:560px){.hwrap .cta{display:flex!important}}'; (document.head||document.documentElement).appendChild(cs);
/* clicks: runs after every page script, and only where none of them took the click (Quick look, cart drawer …) */
window.addEventListener('click',function(e){
  if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
  var a=e.target&&e.target.closest&&e.target.closest('a[href]'); if(!a) return;
  var raw=a.getAttribute('href'); if(!raw||/^(mailto|tel|javascript):/i.test(raw)) return;
  var m=map(raw); if(!m) return;
  e.preventDefault();
  if(m.url){ if(a.target==='_blank') window.open(m.url,'_blank','noopener'); else location.href=m.url; }
  else jump(m.hash);
});
})();
